import type { CSSProperties, ReactNode } from 'react';

const whiteFolder = { '--folder': 'var(--sheet)', '--folder-fg': 'var(--ink)' } as CSSProperties;

/** Cornice delle schermate di accesso: il modulo è dentro una cartellina bianca con la linguetta "Regia". */
export function AuthFrame({
  title,
  subtitle,
  children,
}: {
  title: string;
  subtitle?: ReactNode;
  children: ReactNode;
}) {
  return (
    <main className="flex min-h-dvh flex-col items-center justify-center bg-paper px-4 py-10 safe-top">
      <div className="w-full max-w-[26rem]">
        <div style={whiteFolder} className="drop-shadow-[0_24px_40px_rgb(24_36_74/0.16)]">
          <div className="flex px-6">
            <span className="folder-tab text-[1.0625rem]">Regia</span>
          </div>
          <div className="rounded-[20px] bg-sheet px-6 pt-7 pb-7 sm:px-8">
            <h1 className="t-display text-[1.75rem] text-ink">{title}</h1>
            {subtitle ? <p className="mt-2 text-[0.9375rem] text-ink-2">{subtitle}</p> : null}
            <div className="mt-6">{children}</div>
          </div>
        </div>
        <p className="mt-7 px-2 text-center text-sm text-ink-3">
          Pagine social, siti e attività in un solo posto.
        </p>
      </div>
    </main>
  );
}
